/**
 * Live Google-Bewertungen über die Places API (JS-SDK, PlacesService).
 * Key + Place-ID kommen aus den Theme-Settings (Admin → Theme anpassen →
 * Kontakt & Standort). Der Key muss im Google-Cloud-Projekt per
 * HTTP-Referrer auf die Shop-Domain beschränkt sein.
 *
 * Google liefert über dieses Feld ohnehin nur die 5 relevantesten
 * Bewertungen zurück — mehr geht mit der Places API nicht.
 *
 * Ergebnis wird pro Browser-Session zwischengespeichert (sessionStorage),
 * damit nicht bei jedem Seitenaufruf neu abgefragt wird.
 */
(function () {
  var CACHE_KEY = 'vp_google_reviews_v1';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 Stunden

  var section = document.querySelector('[data-google-reviews]');
  if (!section) return;
  var placeId = section.getAttribute('data-place-id');
  var apiKey = section.getAttribute('data-api-key');
  if (!placeId || !apiKey) {
    section.hidden = true;
    return;
  }

  var grid = section.querySelector('[data-reviews-grid]');
  var summary = section.querySelector('[data-reviews-summary]');

  function starsSVG(count) {
    var full = Math.round(count);
    var html = '';
    for (var i = 0; i < 5; i++) {
      html += '<svg viewBox="0 0 20 20" fill="' + (i < full ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="1.4"><path d="M10 1.6l2.5 5.3 5.7.6-4.3 4 1.2 5.7L10 14.6l-5.1 2.6 1.2-5.7-4.3-4 5.7-.6z" stroke-linejoin="round"/></svg>';
    }
    return html;
  }

  function initials(name) {
    var parts = (name || '').trim().split(/\s+/);
    var a = parts[0] ? parts[0][0] : '';
    var b = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (a + b).toUpperCase() || 'G';
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function renderReviews(data) {
    if (!data || !data.reviews || !data.reviews.length) {
      grid.innerHTML = '<p class="review" style="grid-column:1/-1;text-align:center;color:var(--muted)">Aktuell keine Bewertungen verfügbar.</p>';
      return;
    }

    if (summary && data.rating) {
      section.querySelector('[data-reviews-rating]').textContent = data.rating.toFixed(1).replace('.', ',');
      section.querySelector('[data-reviews-stars]').innerHTML = starsSVG(data.rating);
      section.querySelector('[data-reviews-count]').textContent = data.userRatingsTotal || data.reviews.length;
      summary.hidden = false;
    }

    var gIcon = '<svg viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>';

    grid.innerHTML = data.reviews.slice(0, 5).map(function (r) {
      var text = (r.text || '').trim();
      if (text.length > 260) text = text.slice(0, 257).trim() + '…';
      return (
        '<div class="review">' +
          '<div class="review__top">' +
            '<div class="review__avatar">' + initials(r.authorName) + '</div>' +
            '<div>' +
              '<div class="review__who">' + escapeHTML(r.authorName || 'Google-Nutzer') + '</div>' +
              '<div class="review__date">' + escapeHTML(r.relativeTime || '') + '</div>' +
            '</div>' +
          '</div>' +
          '<span class="review-stars" aria-hidden="true">' + starsSVG(r.rating || 5) + '</span>' +
          '<p class="review__text">' + escapeHTML(text) + '</p>' +
          '<div class="review__g">' + gIcon + ' Google-Bewertung</div>' +
        '</div>'
      );
    }).join('');
  }

  function getCached() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return parsed.data;
    } catch (e) { return null; }
  }

  function setCached(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) { /* Storage voll/deaktiviert — dann eben ohne Cache */ }
  }

  function fetchFromGoogle() {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      section.hidden = true; // Google nicht erreichbar/keine Abrechnung → lieber nichts als eine Fehlermeldung
      return;
    }
    var service = new google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails({
      placeId: placeId,
      fields: ['reviews', 'rating', 'user_ratings_total']
    }, function (place, status) {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !place) {
        section.hidden = true; // Google nicht erreichbar/keine Abrechnung → lieber nichts als eine Fehlermeldung
        return;
      }
      var data = {
        rating: place.rating,
        userRatingsTotal: place.user_ratings_total,
        reviews: (place.reviews || []).map(function (r) {
          return {
            authorName: r.author_name,
            rating: r.rating,
            text: r.text,
            relativeTime: r.relative_time_description
          };
        })
      };
      setCached(data);
      renderReviews(data);
    });
  }

  // Google meldet fehlende Abrechnung nur in der Konsole, der Callback kommt
  // dann nie → nach 8 s ohne Ergebnis Sektion ausblenden.
  var watchdog = setTimeout(function () {
    if (section.querySelector('[data-reviews-loading]')) section.hidden = true;
  }, 8000);

  window.__vpInitGoogleReviews = function () {
    var cached = getCached();
    if (cached) {
      renderReviews(cached);
      return;
    }
    fetchFromGoogle();
  };

  if (!document.querySelector('script[data-google-maps-loader]')) {
    var script = document.createElement('script');
    script.setAttribute('data-google-maps-loader', 'true');
    script.async = true;
    script.defer = true;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=places&callback=__vpInitGoogleReviews';
    document.head.appendChild(script);
  } else if (window.google && window.google.maps && window.google.maps.places) {
    window.__vpInitGoogleReviews();
  }
})();
